export default __webpack_public_path__ + "static/media/W51Bath4.d68e82cc.jpg";